import {
  MembershipService,
  PackageService,
  ProductService,
  RoleService,
  SalonServices,
  StaffManagement,
  UserService,
  OurBestService,
  CartService,
  BookingServices,
  Specialists,
  AdvertisementService,
  MediaService,
  FileService,
  GeneralService,
  ClientService,
  UnitService,
  VendorService,
  SeatService,
  AttendanceService,
  InventoryService,
  OrderService,
  billingservice,
  surveyService,
  clientsurveyservice,
  taskservice,
  taskevidenceservice
} from "../../../constant/Constant"

// ========================================
// USER MANAGEMENT
// ========================================
export const addUser = UserService + 'addUser'
export const updateUser = UserService + 'updateUser'
export const searchUser = UserService + 'searchUser'
export const deleteUser = UserService + 'deleteUser'


// ========================================
// CLIENT MANAGEMENT
// ========================================
export const addClient = ClientService + 'addClients'
export const updateClient = ClientService + 'updateClients'
export const searchClient = ClientService + 'searchClients'
export const deleteClient = ClientService + 'deleteClients'

// ========================================
// UNIT MANAGEMENT
// ========================================
export const addUnit = UnitService + 'addUnit'
export const updateUnit = UnitService + 'updateUnit'
export const searchUnit = UnitService + 'searchUnit'
export const deleteUnit = UnitService + 'deleteUnit'

// ========================================
// Vendor MANAGEMENT
// ========================================
export const addVendor = VendorService + 'addVendor'
export const updateVendor = VendorService + 'updateVendor'
export const searchVendor = VendorService + 'searchVendor'
export const deleteVendor = VendorService + 'deleteVendor'



// ========================================
// Seat MANAGEMENT
// ========================================
export const addSeat = SeatService + 'addSeat'
export const updateSeat = SeatService + 'updateSeat'
export const searchSeat = SeatService + 'searchSeat'
export const deleteSeat = SeatService + 'deleteSeat'
export const graphql = SeatService + '/graphql'



// ========================================
// Attnadence MANAGEMENT
// ========================================
export const addAttendance = AttendanceService + 'addAttendance'
export const updateAttendance = AttendanceService + 'updateAttendance'
export const searchAttendance = AttendanceService + 'searchAttendance'
export const deleteAttendance = AttendanceService + 'deleteAttendance'




// ========================================
// Invnetory MANAGEMENT
// ========================================

export const addInventory = InventoryService + 'addInventory'
export const updateInventory = InventoryService + 'updateInventory'
export const deleteInventory = InventoryService + 'deleteInventory'
export const searchInventory = InventoryService + 'searchInventory'

// ========================================
// Order MANAGEMENT
// ========================================


export const addOrder = OrderService + 'addOrder'
export const updateOrder = OrderService + 'updateOrder'
export const searchOrder = OrderService + 'searchOrder'
export const deleteOrder = OrderService + 'deleteOrder'

// ========================================
// SALON SERVICES MANAGEMENT
// ========================================

// ========================================
// PARENT SERVICE MANAGEMENT
// ========================================
export const addParent = SalonServices + 'addParent'
export const updateParent = SalonServices + 'updateParent'
export const searchParent = SalonServices + 'searchParent'
export const deleteParent = SalonServices + 'deleteParent'
export const ParentBulkUpload = SalonServices + 'bulk-upload'

// ========================================
// CHILD SERVICE MANAGEMENT
// ========================================
export const addChild = SalonServices + 'addChild'
export const updateChild = SalonServices + 'updateChild'
export const searchChild = SalonServices + 'searchChild'
export const deleteChild = SalonServices + 'deleteChild'


// ========================================
// PRODUCT MANAGEMENT
// ========================================
export const addProduct = ProductService + 'addProduct'
export const updateProduct = ProductService + 'updateProduct'
export const searchProduct = ProductService + 'searchProduct'
export const deleteProduct = ProductService + 'deleteProduct'
export const ProductBulkUpload = ProductService + 'bulk-upload'

// ========================================
// STAFF MANAGEMENT
// ========================================
export const addStaff = StaffManagement + 'addStaff'
export const updateStaff = StaffManagement + 'updateStaff'
export const searchStaff = StaffManagement + 'searchStaff'
export const deleteStaff = StaffManagement + 'deleteStaff'
export const StaffBulkUpload = StaffManagement + 'bulk-upload'



// export const addAttendance = GatewayBase + AttendanceService + 'addAttendance'
// export const updateAttendance = GatewayBase + AttendanceService + 'updateAttendance'
// export const searchAttendance = GatewayBase + AttendanceService + 'searchAttendance'
// export const deleteAttendance = GatewayBase + AttendanceService + 'deleteAttendance'


// ========================================
//  GNERAL MASTER
// ========================================

export const addGeneralMaster = GeneralService + 'addGeneral'
export const updateGeneralMaster = GeneralService + 'updateGeneral'
export const deleteGeneralMaster = GeneralService + 'deleteGeneral'
export const searchGeneralMaster = GeneralService + 'searchGeneral'

// ========================================
// FILE MANAGEMENT
// ========================================
export const uploadSingle = FileService + 'uploadSingle'
export const searchFiles = FileService + 'searchFiles'
export const deleteFile = FileService + 'deleteFile'


// ========================================
// ROLES AND PERMISSIONS
// ========================================
export const addRole = RoleService + 'addRole'
export const updateRole = RoleService + 'updateRole'
export const searchRole = RoleService + 'searchRole'
export const deleteRole = RoleService + 'deleteRole'


// ========================================
// BILLING MANAGEMENT
// ========================================

export const addBilling = billingservice + "addBilling"
export const searchBilling = billingservice + 'searchBilling'
export const updateBilling = billingservice + 'updateBilling'
export const deleteBilling = billingservice + 'deleteBilling'

// ========================================
// Staff BILLING MANAGEMENT
// ========================================

export const addBill = billingservice + 'addBill'
export const searchBill = billingservice + 'searchBill'
export const updateBill = billingservice + 'updateBill'
export const deleteBill = billingservice + 'deleteBill'


// ========================================
// CLIENT FOLLOW UP MANAGEMENT
// ========================================
export const addClientFollowUp = ClientService + 'addClientFollowUp'
export const updateClientFollowUp = ClientService + 'updateClientFollowUp'
export const searchClientFollowUp = ClientService + 'searchClientFollowUp'
export const deleteClientFollowUp = ClientService + 'deleteClientFollowUp'












// ========================================
// ADVERTISEMENT MANAGEMENT
// ========================================
export const addAdvertisement = AdvertisementService + 'addAdvertisement'
export const updateAdvertisement = AdvertisementService + 'updateAdvertisement'
export const searchAdvertisement = AdvertisementService + 'searchAdvertisement'
export const deleteAdvertisement = AdvertisementService + 'deleteAdvertisement'

// ========================================
// MEDIA MANAGEMENT
// ========================================
export const addMedia = MediaService + 'addMedia'
export const updateMedia = MediaService + 'updateMedia'
export const searchMedia = MediaService + 'searchMedia'
export const deleteMedia = MediaService + 'deleteMedia'





// ========================================
// SURVEY MANAGEMENT
// ========================================

export const addSurvey = surveyService + "addSurvey"
export const searchSurvey = surveyService + 'searchSurvey'
export const updateSurvey = surveyService + 'updateSurvey'
export const deleteSurvey = surveyService + 'deleteSurvey'



// ========================================
// CLIENT SURVEY MANAGEMENT
// ========================================

export const addClientSurvey = clientsurveyservice + "addClientSurvey"
export const searchClientSurvey = clientsurveyservice + 'searchClientSurvey'
export const updateClientSurvey = clientsurveyservice + 'updateClientSurvey'
export const deleteClientSurvey = clientsurveyservice + 'deleteClientSurvey'




// ========================================
// TASK MANAGEMENT
// ========================================


export const searchTask = taskservice + "searchTask"
export const createTask = taskservice + "createTask"
export const deleteTask = taskservice + "deleteTask"
export const updateTask = taskservice + 'updateTask'
export const searchEvidence = taskevidenceservice + "searchTaskEvidence"
export const updateTaskEvidence = taskevidenceservice + "updateTaskEvidence"






































// Authentication (if you need them separately)
export const login = UserService + 'login'
export const sendOtp = UserService + 'sendOtp'
export const verifyOtp = UserService + 'verifyOtp'



// ========================================
// MEMBERSHIP MANAGEMENT
// ========================================
export const addMembership = MembershipService + 'addMembership'
export const updateMembership = MembershipService + 'updateMembership'
export const searchMembership = MembershipService + 'searchMembership'
export const deleteMembership = MembershipService + 'deleteMembership'
export const MembershipBulkUpload = MembershipService + 'bulk-upload'







// ========================================
// PACKAGE MANAGEMENT
// ========================================
export const addPackage = PackageService + 'addPackage'
export const updatePackage = PackageService + 'updatePackage'
export const searchPackage = PackageService + 'searchPackage'
export const deletePackage = PackageService + 'deletePackage'








// ========================================
// CART MANAGEMENT
// ========================================
export const addCart = CartService + 'addCart'
export const searchCart = CartService + 'searchCart'
export const deleteCart = CartService + 'deleteCart'

// ========================================
// BOOKING MANAGEMENT
// ========================================
export const addBooking = BookingServices + 'addBooking'
export const searchBooking = BookingServices + 'searchBooking'



// ========================================
// SPECIALISTS MANAGEMENT
// ========================================
export const searchSpecialists = Specialists + 'searchSpecialists'




